var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/quickship-info-modal.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/modal/quickship-info-modal.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("staticUrl")) {
var t_4 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_4);
env.getTemplate("modal/modal-contents.j2", true, "core/templates/modal/quickship-info-modal.j2", false, function(t_6,_parentTemplate) {
if(t_6) { cb(t_6); return; }
parentTemplate = _parentTemplate
for(var t_5 in parentTemplate.blocks) {
context.addBlock(t_5, parentTemplate.blocks[t_5]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n    o-modal--small\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n<div class=\"c-quickship-info-modal\">\n    <img class=\"c-quickship-info-modal__logo\" src=\"";
output += runtime.suppressValue((lineno = 10, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "staticUrl"), "staticUrl", context, ["/images/modal/quickship-info-logo.svg"])), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 10, colno = 112, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickship_info_modal_logo-alt"])), env.opts.autoescape);
output += "\" />\n\n    <h2 class=\"c-quickship-info-modal__heading\">";
output += runtime.suppressValue((lineno = 12, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickship_info-heading"])), env.opts.autoescape);
output += "</h2>\n\n    <p class=\"c-quickship-info-modal__text\">";
output += runtime.suppressValue((lineno = 14, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickship_info_modal-detail"])), env.opts.autoescape);
output += "</p>\n</div>";
if(runtime.contextOrFrameLookup(context, frame, "showBackToProduct")) {
output += "<a href=\"#\" class=\"js-back-to-product c-quickship-info-modal__back-to-product-link\">";
output += runtime.suppressValue((lineno = 18, colno = 90, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickship_info_modal-back-to-product"])), env.opts.autoescape);
output += "</a>";
;
}
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/quickship-info-modal.j2"] , dependencies)